/* Lactolerance — fade the loyalty (Fidélité) + Crisp chat widgets while the page is
   scrolling on mobile, so they don't sit over the content. They fade back in when the
   scroll stops. Desktop is untouched. Pure add-on: does nothing if no widget is present. */
(function () {
  var root = document.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var timer;
  function onScroll() {
    if (mq && !mq.matches) return; // mobile only
    root.classList.add('lacto-scrolling');
    clearTimeout(timer);
    timer = setTimeout(function () { root.classList.remove('lacto-scrolling'); }, 550);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
